import React from 'react';

const LeftArrow = () => (
  <svg
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.569969 6.41058C0.343213 6.18382 0.343213 5.81618 0.569969 5.58942L5.98932 0.170068C6.21608 -0.0566882 6.58372 -0.0566882 6.81048 0.170068C7.03724 0.396823 7.03724 0.764468 6.81048 0.991223L1.8017 6L6.81048 11.0088C7.03724 11.2355 7.03724 11.6032 6.81048 11.8299C6.58372 12.0567 6.21608 12.0567 5.98932 11.8299L0.569969 6.41058Z"
      fill="#15372C"
    />
  </svg>
);

const RightArrow = () => (
  <svg
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.42954 5.58942C6.6563 5.81618 6.6563 6.18382 6.42954 6.41058L1.01019 11.8299C0.783431 12.0567 0.415787 12.0567 0.189031 11.8299C-0.0377245 11.6032 -0.0377245 11.2355 0.189031 11.0088L5.19781 6L0.189032 0.991223C-0.0377241 0.764467 -0.037724 0.396823 0.189032 0.170067C0.415788 -0.0566893 0.783432 -0.0566893 1.01019 0.170067L6.42954 5.58942Z"
      fill="#15372C"
    />
  </svg>
);

export default {
  LeftArrow,
  RightArrow,
};
